module.exports = __webpack_public_path__ + "static/media/communication-collaboration.cbaa0c56.svg";